import {
  ResponseTypeEnum,
  TemplateNodeSchema,
} from '@ulysses-inc/harami_api_client'
import { useSelector } from 'react-redux'
import { RootState } from 'src/state/store'
import {
  buildSiblingQuestionMapByUuid,
  findSiblingNodeIds,
} from './siblingNodes'

/**
 * 指定した質問と同じ親(セクション・条件分岐・ページ)の直下にある、指定した回答種別の質問を返す。
 *
 * 計算式・ラベル検査のように「同じ親に属する質問のみ参照できる」設定の参照先候補に使う。
 *
 * @param nodeId 対象の質問ノード id
 * @param responseType 候補にする回答種別
 */
export const useSiblingQuestions = (
  nodeId: number,
  responseType: ResponseTypeEnum,
): TemplateNodeSchema[] => {
  const { templatePages, templateNodes } = useSelector(
    (state: RootState) => state.templatesState.templatePages,
  )

  const siblingNodeIds =
    findSiblingNodeIds(
      nodeId,
      Object.values(templateNodes),
      Object.values(templatePages),
    ) ?? []

  return [
    ...buildSiblingQuestionMapByUuid(
      siblingNodeIds,
      templateNodes,
      responseType,
    ).values(),
  ]
}
